// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-player__media[data-v-0269680c] {
  width: 100%;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/components/MediaPlayer.vue","webpack://./MediaPlayer.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,cAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.media-player__media {\n  width: 100%;\n  display: block;\n}\n",".media-player__media {\n  width: 100%;\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
